import "./index.scss";
import AnimatedLetters from "../AnimatedLetters";
import { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import { useTranslate } from "../../context/TranslateContext";
import T from "../Translate/T";

const Layout = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const { currentLang, translateText, translateBatch, isEnglish } = useTranslate();
  const [translatedStrings, setTranslatedStrings] = useState([]);
  
  // Translated greeting parts
  const [hiArray, setHiArray] = useState(["H", "i", ","]);
  const [imArray, setImArray] = useState(["I", "'", "m"]);
  const [nameArray, setNameArray] = useState(["C", "a", "r", "l", "o", "s", ","]);
  const [jobArray, setJobArray] = useState([
    "F", "u", "l", "l", " ", "S", "t", "a", "c", "k", " ",
    "E", "n", "g", "i", "n", "e", "e", "r"
  ]);

  // Original English strings for typewriter
  const originalStrings = [
    "Software Engineer",
    "PHP - Laravel",
    "React",
    "Next.js",
    "Big Data Analyst - Toronto Metropolitan University",
    "Bachelor's Degree in Computer Science",
    "Oracle PL/SQL Certified Associate",
    "Certificate in Web Design - Humber College",
    "E-Commerce and Internet Development - University of Toronto",
    "Mobile Developer Certificate - Ryerson University",
  ];

  useEffect(() => {
    setTimeout(() => {
      clearTimeout();
      setLetterClass("text-animate-hover");
    }, 4000);
  }, []);

  // Translate greeting and job title when language changes
  useEffect(() => {
    const translateGreeting = async () => {
      if (isEnglish) {
        setHiArray(["H", "i", ","]);
        setImArray(["I", "'", "m"]);
        setNameArray(["C", "a", "r", "l", "o", "s", ","]);
        setJobArray(["F", "u", "l", "l", " ", "S", "t", "a", "c", "k", " ", "E", "n", "g", "i", "n", "e", "e", "r"]);
        return;
      }

      try {
        // Translate "Hi," "I'm" and "Full Stack Engineer"
        const results = await translateBatch(["Hi,", "I'm", "Full Stack Engineer"], currentLang);
        
        // Convert translated strings to character arrays
        const hiTranslated = results[0] || "Hi,";
        const imTranslated = results[1] || "I'm";
        const jobTranslated = results[2] || "Full Stack Engineer";
        
        setHiArray(hiTranslated.split(""));
        setImArray(imTranslated.split(""));
        // Keep "Carlos" as is (it's a name)
        setNameArray(["C", "a", "r", "l", "o", "s", ","]);
        setJobArray(jobTranslated.split(""));
      } catch (error) {
        console.error("Translation error:", error);
      }
    };

    translateGreeting();
  }, [currentLang, isEnglish, translateBatch]);

  // Translate typewriter strings when language changes
  useEffect(() => {
    const translateStrings = async () => {
      if (isEnglish) {
        setTranslatedStrings(originalStrings);
        return;
      }

      try {
        const results = await translateBatch(originalStrings, currentLang);
        const translated = originalStrings.map((_, index) => results[index] || originalStrings[index]);
        setTranslatedStrings(translated);
      } catch (error) {
        console.error("Translation error:", error);
        setTranslatedStrings(originalStrings);
      }
    };

    translateStrings();
  }, [currentLang, isEnglish, translateBatch]);

  return (
    <div className="page">
      {/* here to put the component for animation */}
      <div className="container home-page">
        
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              key={`hi-${currentLang}`}
              letterClass={letterClass}
              strArray={hiArray}
              idx={1}
            />
            <br />
            <AnimatedLetters
              key={`im-${currentLang}`}
              letterClass={letterClass}
              strArray={imArray}
              idx={hiArray.length + 2}
            />
            <span className={letterClass}>&nbsp;</span>
            <AnimatedLetters
              key={`name-${currentLang}`}
              letterClass={letterClass}
              strArray={nameArray}
              idx={hiArray.length + imArray.length + 3}
            />
            <br />
            <AnimatedLetters
              key={`job-${currentLang}`}
              letterClass={letterClass}
              strArray={jobArray}
              idx={hiArray.length + imArray.length + nameArray.length + 4}
            />
          </h1>

          <h2>
            {/* Web Developer / PHP / React / Next.Js / Big Data Analyst  */}
            <Typewriter
              key={currentLang} // Force re-render when language changes
              options={{
                strings: translatedStrings.length > 0 ? translatedStrings : originalStrings,
                autoStart: true,
                loop: true,
              }}
            />{" "}
          </h2>
          <a href="#contact" className="flat-button">
            <T>Contact Me</T>
          </a>
        </div>
        
      </div>
    </div>
  );
};
export default Layout;